var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnymail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "225.000000pt",
    height: "225.000000pt",
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M985 2240 c-256 -36 -469 -142 -651 -324 -156 -156 -248 -319 -301 -532 -23 -94 -27 -129 -27 -259 0 -130 4 -165 27 -259 53 -213 145 -376 301 -532 156 -156 319 -248 532 -301 94 -23 129 -27 259 -27 130 0 165 4 259 27 213 53 376 145 532 301 156 156 248 319 301 532 23 94 27 129 27 259 0 130 -4 165 -27 259 -53 213 -145 376 -301 532 -155 155 -320 248 -527 299 -116 28 -302 40 -404 25z m319 -522 c40 -40 110 -123 157 -183 103 -133 122 -162 116 -172 -3 -5 -54 -5 -114 -1 -59 3 -288 16 -508 28 -220 13 -404 26 -409 31 -13 12 3 23 183 125 256 145 446 238 495 243 4 1 41 -32 80 -71z m-715 -413 c216 -138 444 -260 555 -299 18 -6 16 -10 -15 -42 -19 -20 -81 -75 -139 -122 -130 -106 -149 -124 -85 -82 96 64 351 258 534 404 140 113 188 146 199 139 9 -5 29 -68 49 -159 19 -82 50 -214 69 -294 32 -137 33 -146 16 -161 -19 -18 15 -11 -856 -168 -153 -28 -225 -37 -238 -30 -20 11 -27 33 -73 239 -72 317 -98 429 -120 525 -22 94 -24 115 -6 115 4 0 53 -29 110 -65z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnymail);
export default __webpack_public_path__ + "static/media/anymail.5e2d5200cfa638f95384e40392923eba.svg";
export { ForwardRef as ReactComponent };